import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";

export function OtherForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("low");
    const [category, setCategory] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            title: baseForm.title,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                category: category,
            },
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                    allowedPriorities={allowedPriorities}
                titlePlaceholder="Décrivez votre demande"
                descriptionPlaceholder="Détaillez votre demande..."
            >
                <div className="form-group">
                    <Label className="form-label">Catégorie</Label>
                    <Input
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        placeholder="Ex: Suggestion, Réclamation, Demande spéciale..."
                        data-testid="category"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
